module.exports = __webpack_public_path__ + "img/facebook.b80504e3.svg";